// extracted by mini-css-extract-plugin
export var TextinfoNoProduct = "styles-module--TextinfoNoProduct--UPW1X";
export var boutiqueTitle = "styles-module--boutiqueTitle--nKsRP";
export var contentContainer = "styles-module--contentContainer--+ykK7";
export var store = "styles-module--store--U18cM";